import { useDispatch, useSelector } from "react-redux";

import { Button } from "components/Button";
import { showUpgradePremiumModalSelect } from "Layout/slice/selector";
import { toggleUpgradePremiumModal } from "Layout/slice";
import { Title } from "style/components/Title.styles";
import { iconUpgradePlan } from "assets/icons";
import { useNavigation } from "utils/navigate";
import { UpgradePremiumModalContainer } from "./UpgradePremiumModal.styles";

const UpgradePremiumModal = () => {
  const dispatch = useDispatch();
  const showUpgradePremiumModal = useSelector(showUpgradePremiumModalSelect);

  const { navigateToPlans } = useNavigation();

  const handleHide = () => {
    dispatch(toggleUpgradePremiumModal(""));
  };

  const handleUpgradeClick = () => {
    navigateToPlans();
    handleHide();
  };

  return (
    <UpgradePremiumModalContainer
      show={showUpgradePremiumModal ? true : false}
      onHide={handleHide}
    >
      <img src={iconUpgradePlan} />
      <Title>Upgrade to get more from Surmount</Title>
      <p>{showUpgradePremiumModal}</p>
      <div className="button-wrapper">
        <Button onClick={handleUpgradeClick}>Upgrade now</Button>
        <Button variant="outlined" onClick={handleHide}>
          Continue without premium
        </Button>
      </div>
    </UpgradePremiumModalContainer>
  );
};

export { UpgradePremiumModal };
